/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsAnalyticsService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './SalesDocumentsAnalyticsService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsAnalyticsService#getDocumentAnalyticsSummary
 */
export const GET_DOCUMENT_ANALYTICS_SUMMARY_QUERY_FIELD_NAME = 'com_hubspot_sales_documents_rpc_SalesDocumentsAnalyticsService_getDocumentAnalyticsSummary';
export const GET_DOCUMENT_ANALYTICS_SUMMARY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_DOCUMENT_ANALYTICS_SUMMARY_QUERY_FIELD_NAME,
  args: ['documentId'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getDocumentAnalyticsSummaryRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsAnalyticsService#getVisitorsForDocument
 */
export const GET_VISITORS_FOR_DOCUMENT_QUERY_FIELD_NAME = 'com_hubspot_sales_documents_rpc_SalesDocumentsAnalyticsService_getVisitorsForDocument';
export const GET_VISITORS_FOR_DOCUMENT_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_VISITORS_FOR_DOCUMENT_QUERY_FIELD_NAME,
  args: ['documentId', 'limit', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient2;
    return ((_ctx$customClient2 = ctx.customClient) !== null && _ctx$customClient2 !== void 0 ? _ctx$customClient2 : chirpClient).call(References.getVisitorsForDocumentRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsAnalyticsService#getVisitsForDocumentAndViewerId
 */
export const GET_VISITS_FOR_DOCUMENT_AND_VIEWER_ID_QUERY_FIELD_NAME = 'com_hubspot_sales_documents_rpc_SalesDocumentsAnalyticsService_getVisitsForDocumentAndViewerId';
export const GET_VISITS_FOR_DOCUMENT_AND_VIEWER_ID_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_VISITS_FOR_DOCUMENT_AND_VIEWER_ID_QUERY_FIELD_NAME,
  args: ['documentId', 'viewerId', 'limit', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient3;
    return ((_ctx$customClient3 = ctx.customClient) !== null && _ctx$customClient3 !== void 0 ? _ctx$customClient3 : chirpClient).call(References.getVisitsForDocumentAndViewerIdRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.sales.documents.rpc.SalesDocumentsAnalyticsService#getVisitorsForDocumentAndSearchQuery
 */
export const GET_VISITORS_FOR_DOCUMENT_AND_SEARCH_QUERY_QUERY_FIELD_NAME = 'com_hubspot_sales_documents_rpc_SalesDocumentsAnalyticsService_getVisitorsForDocumentAndSearchQuery';
export const GET_VISITORS_FOR_DOCUMENT_AND_SEARCH_QUERY_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_VISITORS_FOR_DOCUMENT_AND_SEARCH_QUERY_QUERY_FIELD_NAME,
  args: ['documentId', 'searchQuery', 'limit', 'offsetMaybe', 'offset'],
  fetcher(request, ctx) {
    var _ctx$customClient4;
    return ((_ctx$customClient4 = ctx.customClient) !== null && _ctx$customClient4 !== void 0 ? _ctx$customClient4 : chirpClient).call(References.getVisitorsForDocumentAndSearchQueryRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});